import {
    initDimensionsFromState,
    trackInitialPageView,
    trackAnalyticsEvent,
} from '@eventbrite/site-analytics';

const DEFAULT_ANALYTICS_CATEGORY = 'one-checkout';

const analyticsServiceFactory = ({ props = {}, getEventId }) => {
    const eventId = getEventId();

    const trackAction = ({
        action,
        category = DEFAULT_ANALYTICS_CATEGORY,
        label,
    }) => {
        trackAnalyticsEvent({
            action,
            category,
            label,
            eventId,
        });
    };
    const gaSettings = props.gaSettings || {};
    const propsToUse = {
        ...props,
        gaSettings: {
            ...gaSettings,
        },
        eventId,
    };

    initDimensionsFromState(propsToUse);

    const _trackInitialPageView = () => {
        trackInitialPageView(propsToUse.gaSettings);
    };

    return {
        trackAction,
        trackInitialPageView: _trackInitialPageView,
    };
};

export default analyticsServiceFactory;
